import { useEffect } from "react";
import ProductModalStatus from "src/features/product-modal/components/ProductModalStatus";
import Variants from "src/features/product-modal/components/variants/Variants";
import useProductDetail from "src/features/product-modal/hooks/useProductDetail";
import getEnabledVariants from "src/features/product-modal/util/get-enabled-variants";
import { ProductDetail } from "src/features/products/model/ProductWithVariant";
import { useAppDispatch } from "src/shared/hooks/redux";
import isEmpty from "src/shared/util/is-empty";
import ProductButton from "../../products/components/ProductButton";
import ProductImage from "../../products/components/ProductImage";
import ProductName from "../../products/components/ProductName";
import ProductPrice from "../../products/components/ProductPrice";
import {
  clearErrorByProductId,
  CombinedModalProduct,
} from "../combinedProductSlice";
import useCombinedAddToCard from "../hook/useCombinedAddToCard";
import { DivCombinedProductCard } from "../style/CombinedProductCard.style";

interface Props {
  modalProduct: CombinedModalProduct;
  closeModal?: () => void;
  isVisible: boolean;
}

const CombinedProductModalCard = ({
  modalProduct,
  closeModal = () => null,
  isVisible,
}: Props) => {
  const dispatch = useAppDispatch();
  const { summary, errors, status } = modalProduct;

  const {
    toggleParams,
    data: productDetail,
    isFetching,
  } = useProductDetail<ProductDetail>({
    url: summary?.url,
  });

  // @ts-ignore
  const {
    url,
    name,
    price,
    image,
    productDiscount,
    pk: basePk,
  } = summary ?? {};
  const { variants, selected_variant } = productDetail ?? {};
  const { pk } = selected_variant ?? {};
  const shouldDisableBuying = !isEmpty(errors.waitForStreamStart);
  const enabledVariants = getEnabledVariants(variants ?? []);

  const { onAddToCart } = useCombinedAddToCard({
    shouldDisableBuying,
    closeModal,
    variants,
    pk: pk,
    basePk: basePk,
  });

  useEffect(() => {
    if (productDetail) {
      dispatch(clearErrorByProductId(basePk ?? pk));
    }
  }, [productDetail]);

  if (isEmpty(summary)) return null;

  return (
    <DivCombinedProductCard
      className="akn-combined-product-card"
      $isLoading={status === "loading"}
    >
      {status && <ProductModalStatus isLoading={isFetching} status={status} />}
      <ProductImage src={image!} variant="modal" />

      <div className="akn-combined-modal-details">
        <div className="akn-combined-modal__upper-details">
          <ProductName name={name!} variant="modal" />
          <ProductPrice
            price={+price!}
            showCoupon={true}
            showDiscount={true}
            discount={productDiscount}
            showCopyIcon={true}
            showRetailPrice={false}
          />
          <Variants
            enabledVariants={enabledVariants}
            toggleProductParams={toggleParams}
            variants={variants ?? []}
            isLoading={isFetching}
            errors={errors}
          />
        </div>
        <ProductButton variant="normal" onClick={onAddToCart} href={url} />
      </div>
    </DivCombinedProductCard>
  );
};

export default CombinedProductModalCard;
